import { render, staticRenderFns } from "./info.vue?vue&type=template&id=af678082&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af678082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af678082')) {
      api.createRecord('af678082', component.options)
    } else {
      api.reload('af678082', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=af678082&scoped=true", function () {
      api.rerender('af678082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/sort/components/Category/info.vue"
export default component.exports